import { io, Socket } from "socket.io-client";
import { Account } from "@/types/Account";
import { User } from "@/types/User";
import { Conversation } from "@/types/Conversation";
import { MasterDocument } from "@/types/MasterDocument";
import { MasterRecording } from "@/types/MasterRecording";
import { RecordingSession } from "@/types/RecordingSession";

interface ServerToClientEvents {
	account_update: (data: { account: Account; user: User }) => void;
	conversation_update: (data: { conversation: Conversation }) => void;
	masterdocument_create: (data: { masterdocument: MasterDocument }) => void;
	masterdocument_delete: (data: { masterdocument: MasterDocument }) => void;
	masterrecording_delete: (data: { masterrecording: MasterRecording }) => void;
	recordingsession_update: (data: { recordingsession: RecordingSession }) => void;
	update: (data: { notification: any }) => void;
	delete: (data: { notification: any }) => void;
	mention: (data: { notification: any }) => void;
	comment: (data: { notification: any }) => void;
}

interface ClientToServerEvents {}

export interface AccountUpdateDetail {
	account: Account;
	user: User;
}

export interface SocketConversationUpdate {
	conversation: Conversation;
}

const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(`${SOCKET_URL}/admin`, {
	transports: ["websocket", "polling"],
	tryAllTransports: true,
	withCredentials: true,
	autoConnect: false,
	reconnection: true,
	reconnectionAttempts: Infinity,
	reconnectionDelay: 1000,
	reconnectionDelayMax: 15000,
	randomizationFactor: 0.5
});

socket.on("connect_error", (error) => {
	console.warn("Socket connection error:", (error as any)?.message || error);
});

socket.on("connect", () => {
	console.info("Socket connected", socket.id);
});

socket.on("disconnect", (reason) => {
	console.warn("Socket disconnected:", reason);
});

export default socket;
